export default __webpack_public_path__ + "static/media/sterling.22f81a1c.png";